import { z } from 'zod';

/**
 * A2 form schema (はり・きゅう)
 * - degree_of_pain: 0-10, default 5
 */
export const longTermFrequentA2Schema = z.object({
  visit_yearmonth: z
    .string()
    .min(1, '施術年月は必須です。')
    .regex(/^\d{6}$/, '施術年月は"Ym"書式と一致していません。'),
  valuation_date: z.string().min(1, '患者状態評価日は必須です。'),
  degree_of_pain: z
    .number()
    .int()
    .min(0)
    .max(10)
    .default(5),
  recovery_type_id: z.number().int().min(0).nullable().optional(),
  massager_id: z.number().int().nullable().optional(),
  treatment_continuation_reason: z
    .string()
    .min(1, '施術が必要な理由は必須です。')
    .max(1000, '施術が必要な理由は1000文字以下にしてください。'),
  create_document_date: z.string().min(1, '作成日は必須です。'),
});

/**
 * R2 form schema (マッサージ)
 * - 5 valuation type fields instead of degree_of_pain
 */
export const longTermFrequentR2Schema = z.object({
  visit_yearmonth: z
    .string()
    .min(1, '施術年月は必須です。')
    .regex(/^\d{6}$/, '施術年月は"Ym"書式と一致していません。'),
  valuation_date: z.string().min(1, '患者状態評価日は必須です。'),
  valuation_betray_type_id: z.number().int().min(1).default(1),
  valuation_sit_up_type_id: z.number().int().min(1).default(1),
  valuation_sitting_type_id: z.number().int().min(1).default(1),
  valuation_stand_up_type_id: z.number().int().min(1).default(1),
  valuation_standing_type_id: z.number().int().min(1).default(1),
  recovery_type_id: z.number().int().min(0).nullable().optional(),
  massager_id: z.number().int().nullable().optional(),
  treatment_continuation_reason: z
    .string()
    .min(1, '施術が必要な理由は必須です。')
    .max(1000, '施術が必要な理由は1000文字以下にしてください。'),
  create_document_date: z.string().min(1, '作成日は必須です。'),
});

export type LongTermFrequentA2FormData = z.infer<typeof longTermFrequentA2Schema>;
export type LongTermFrequentR2FormData = z.infer<typeof longTermFrequentR2Schema>;
